import { Trans, useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { getEnvConfig } from "@configs/env";
import { CircularProgress } from '@mui/material';
import { useGetCategories } from '@queryHooks/useCategory';
import * as S from './ProductInCompanyListStyles';

export const ProductInCompanyList = () => {
  const { t } = useTranslation();
  const { CUSTOM_ROOT_CATEGORY } = getEnvConfig();
  const supportsCustomCategory = CUSTOM_ROOT_CATEGORY?.toLowerCase() === 'true';

  const { data: rootCategories, isFetching } = useGetCategories({ isRootCategory: true });

  const tabList =
    supportsCustomCategory && rootCategories
      ? rootCategories.content.map(category => ({ name: category.name, path: category.id }))
      : [
          { name: t('Subscrib_Detail_Overview_11'), path: 'software' },
          { name: t('Subscrib_Detail_Overview_12'), path: 'hardware' },
        ];
  if (isFetching) return <CircularProgress />;

  return (
    <S.Container>
      <S.Header>
        <p>
          <Trans
            i18nKey="Subscription_In_Company_List_01"
            components={{ 1: <strong className="name" />, 2: <span /> }}
          />
        </p>
      </S.Header>
      <S.Body>
        <S.StyledRoutingTabs className="subscription_tab" tabList={tabList} variant="contain" />
        <Outlet />
      </S.Body>
    </S.Container>
  );
};
